import type { MemoryDictionary } from '../memoryContract'

const memory = {
  page: {
    eyebrow: '企業行銷記憶',
    title: '企業行銷記憶',
    intro: '這裡不是資料庫。它呈現領航者目前如何理解這家企業，並讓診斷、行動、發布與複盤從同一份認知繼續。',
    updated: '企業記憶已更新',
    lastUpdated: '上次更新 · {date}',
    reportIssue: '這裡有一處不對',
  },
  tabs: {
    overview: '目前理解',
    cognition: '企業認知',
    knowledge: '知道什麼',
    strategy: '怎麼做',
    identity: '它是誰',
    connections: '如何相連',
  },
  cognition: {
    title: '領航者如何認識這家企業', body: '隨時回看已確認的初始畫像與完整企業研究。它們是目前專案長期保存的認知成果，不是一次性接入頁面。', assets: '份認知成果', loading: '正在讀取企業認知', loadingBody: '正在取回目前專案已確認的企業畫像與企業研究。', error: '暫時無法讀取企業認知', errorBody: '其他企業記憶沒有改變；可以重新讀取這兩份成果。', profileEyebrow: '初始畫像', profileTitle: '已確認的企業畫像', researchEyebrow: '企業研究', researchTitle: '完整研究綜合', notCreated: '尚未形成', completed: '已完成', confirmedAt: '確認於 {date}', generatedAt: '產生於 {date}', profileEmpty: '目前專案還沒有已確認的初始畫像。', researchEmpty: '目前專案還沒有完成企業研究。', summary: '研究結論', facts: '{count} 條事實', hypotheses: '{count} 條假設', unknowns: '{count} 項未知', candidates: '{count} 個候選', findings: '展開 {count} 條關鍵發現', evidence: '查看事實、假設與未知', knownFacts: '已知事實', hypothesisTitle: '待驗證假設', unknownTitle: '未知與衝突', fields: { brand_identity: '品牌身分', domain_footprint: '官網及相關網域', product_lines: '主要產品或產品線', markets_languages: '目標市場與語言', buyer_types: '典型客戶或買家', competitors: '初始競品參考', public_content_foundation: '公開內容基礎', website_shape: '官網現況', company_type: '初始企業類型' },
  },
  common: {
    confirmed: '已確認',
    awaitingConfirmation: '等待確認',
    awaitingEvidence: '需要更多證據',
    continueObserving: '繼續觀察',
    inProgress: '進行中',
    connected: '已連線',
    view: '檢視',
    close: '關閉',
    cancel: '取消',
    retry: '重試',
    later: '稍後處理',
  },
  contentLanguage: {
    original: '原文 · {language}',
    unchangedHint: '企業事實、品牌原文與證據原句維持原語言。',
  },
  overview: {
    currentUnderstanding: '領航者目前這樣理解 {company} · 等待你確認',
    viewBrandDirection: '檢視品牌意志',
    suggestCorrection: '提出修正',
    sharedUnderstanding: '讓每一項行銷工作從同一份理解繼續',
    map: {
      knowledge: '知道什麼',
      knowledgeHint: '事實與市場',
      strategy: '怎麼做',
      strategyHint: '策略與執行',
      identity: '它是誰',
      identityHint: '價值與取捨',
      connections: '如何相連',
      connectionsHint: '行動與結果',
    },
    cards: {
      knowledgeTitle: '知道什麼',
      knowledgeBody: '檢視已確認的事實、市場如何回應，以及仍需補充的認知。',
      strategyTitle: '怎麼做',
      strategyBody: '檢視本階段的行銷方向、執行進度與下一步建議。',
      identityTitle: '它是誰',
      identityBody: '確認市場應該記住的核心表達、價值支柱與模組角色。',
      connectionsTitle: '如何相連',
      connectionsBody: '看清每項成果從何而來、帶來什麼，以及如何改變下一步。',
      enter: '進入檢視 →',
      confirmedModules: '{count} 條已確認',
      liveOutcomes: '{count} 項成果',
    },
    learning: {
      eyebrow: '最近學習',
      title: '最近學會了什麼',
      body: '領航者會記住哪些表達真正有效、哪些方向仍需驗證，讓下一次工作建立在這一次的結果之上。',
      adopted: '已經使用',
      observing: '繼續驗證',
    },
  },
  knowledge: {
    eyebrow: '知道什麼',
    title: '已經確認什麼，還需要了解什麼',
    body: '在這裡檢視產品事實、市場回饋與仍待補充的資訊，隨時修正領航者對企業的理解。',
    confirmedFacts: '{count} 條已確認公開事實',
    search: '搜尋事實、市場觀察或缺口',
    filter: {
      all: '全部類型',
      facts: '已確認事實',
      market: '市場觀察',
      gaps: '知識缺口',
      outcomes: '產出結果',
    },
    addMaterial: '補充資料',
    category: {
      positioning: '產品定位',
      specification: '產品規格',
      platforms: '平台與版本',
      marketSignal: '市場觀察',
      gap: '知識缺口',
      outcome: '產出結果',
    },
    source: {
      official: '官網公開事實',
      aiMonitoring: 'AI 答案監測',
      awaitingSamples: '等待更多樣本',
      humanReview: '人工評審',
    },
    action: {
      viewBasis: '檢視依據',
      viewFacts: '檢視 {count} 條原始事實',
      viewAnswer: '檢視這次回答',
      viewMissing: '查看還缺什麼',
      viewLearning: '查看學到了什麼',
    },
    status: {
      confirmed: '已確認',
      moreEvidence: '需要更多證據',
      passedReviews: '{count} 次通過',
    },
    noMatchTitle: '沒有找到符合的記憶',
    noMatchBody: '換一個關鍵字，或切回全部類型。',
  },
  strategy: {
    eyebrow: '本階段計畫',
    title: '本階段準備如何推進行銷',
    body: '這裡把目前目標、正在執行的工作、需要你參與的事項與下一步建議放在一起。',
    responsibilitySummary: '領航者負責 {owned} 項 / 需要協作 {collaborative} 項',
    directionAwaiting: '本階段行銷方向 · 等待你確認',
    emptyTitle: '本階段方向尚未確認',
    emptyBody: 'Navigator 不會把一條執行記錄冒充成策略。請先確認階段目標與行銷方向。',
    workEmptyTitle: '尚未安排由 Navigator 推進的工作',
    workEmptyBody: '策略確認並形成實施計畫後，工作會出現在這裡。',
    guidanceEmptyTitle: '目前沒有需要團隊配合的指導事項',
    guidanceEmptyBody: '只有策略需要超出 Navigator 執行邊界的工作時，才會在這裡提供建議。',
    brief: {
      goal: '這個階段要做到',
      message: '希望市場記住',
      reviewWhen: '何時複盤',
    },
    journey: {
      goal: '明確目標',
      goalHint: '希望影響誰、改變什麼',
      theme: '確定主題',
      themeHint: '讓所有內容表達同一個重點',
      work: '推進工作',
      workHint: '內容、頁面、發布與協作',
      feedback: '觀察回饋',
      feedbackHint: 'AI 答案、線索與使用者聲音',
      next: '決定下一步',
      nextHint: '繼續、調整或更換方向',
    },
    navigatorLed: {
      eyebrow: '領航者負責',
      title: '領航者將為你完成',
      body: '以下工作由領航者從方向梳理持續推進到上線與複盤。',
      count: '{count} 項工作',
      positioningTitle: '確定本階段的主張與競爭位置',
      positioningBody: '從買家真正關心的問題出發，說清核心價值、模組作用與選擇理由。',
      contentTitle: '把策略變成可以上線的內容',
      contentBody: '持續製作產品頁、常見問題、買家指南、比較內容與多語言頁面。',
      machineTitle: '讓官網與 AI 同時讀懂新內容',
      machineBody: '在既有官網中補充入口、頁面關係與機器可讀資訊。',
      publishTitle: '發布，並確認每項成果正常可見',
      publishBody: '依照你的授權安排人工、協作或自動發布，並檢查頁面與搜尋入口。',
      reviewTitle: '追蹤市場回饋，準備下一階段',
      reviewBody: '結合 AI 答案、線索與使用者回饋，判斷哪些方向繼續、哪些需要調整。',
      completed: '已完成',
      pagesOnline: '{count} 頁在線',
      ongoing: '持續更新',
      connected: '已連線',
      monitoring: '持續觀察',
    },
    collaboration: {
      eyebrow: '與你的團隊協作',
      title: '這些工作需要你或團隊參與',
      body: '領航者會準備方向與內容，你決定何時啟動，並由相應團隊完成。',
      socialTitle: '{channels} 發聲',
      socialBody: '領航者準備主題、節奏與內容改編，由你確認並發布。',
      socialStatus: '共同完成',
      mediaTitle: '付費媒體',
      mediaBody: '領航者提供受眾、議題與素材建議，由你的媒體團隊安排預算與投放。',
      mediaStatus: '需要帳戶',
      prTitle: '公關、活動與合作',
      prBody: '領航者建議議題、時機與合作方向，由你或合作團隊完成對外溝通。',
      prStatus: '需要團隊',
    },
    results: {
      eyebrow: '市場如何回應',
      title: '下一步怎麼走，由真實回饋決定',
      body: '領航者同時觀察市場如何談論你、什麼樣的客戶正在靠近，以及使用者為什麼選擇或猶豫。',
      aiTitle: 'AI 正在如何談論你',
      aiBody: '持續觀察品牌是否被提及、如何被推薦、與誰一起出現，以及引用了哪些內容。',
      aiAction: '持續監測 · 檢視最新評測 →',
      leadsTitle: '什麼樣的客戶正在靠近',
      leadsBody: '結合線索來源、買家問題與後續進展，判斷行銷是否帶來真正合適的人。',
      leadsAction: '線索已連線 · 檢視線索變化 →',
      surveyTitle: '客戶為什麼選擇或猶豫',
      surveyBody: '直接詢問哪些表達建立了信任、哪裡仍不清楚，以及最終決定受什麼影響。',
      surveyAction: '可以隨時發起 · 建立使用者問卷 →',
    },
    recommendation: {
      continue: '建議繼續',
      adjust: '建議調整',
      schedule: '等待安排',
    },
    methods: {
      eyebrow: '領航者學到的經驗',
      title: '領航者已經學會的工作原則',
      body: '這些經驗來自真實工作與人工判斷，並會持續影響下一次內容與策略。',
      count: '{active} 條已經使用 / {observing} 條繼續驗證',
      search: '搜尋原則',
      filterAll: '全部狀態',
      filterActive: '已經使用',
      filterObserving: '繼續驗證',
      expression: '表達原則',
      competition: '競爭原則',
      promise: '承諾原則',
      inUse: '已經使用',
      validating: '繼續驗證',
      impact: '查看它如何影響工作',
      scope: '檢視適用範圍',
      validation: '查看還需驗證什麼',
      emptyBody: '目前尚無證據足夠的工作方法可以顯示。',
    },
  },
  identity: {
    eyebrow: '希望市場如何記住你',
    title: '{company} 希望被如何理解',
    body: '在這裡確認市場首先應該記住什麼，以及企業的產品與能力如何共同支撐這份認知。',
    confirmedModules: '{count} 條模組表達已確認',
    coreAwaiting: '核心表達 · 等待你確認',
    confirm: '確認這條表達',
    revise: '提出修訂',
    usage: '檢視它將用在哪裡',
    awaitingDecision: '等待你的決定',
    notActive: '核心表達尚未生效',
    afterConfirm: '確認後，領航者會用它統一官網、內容與後續行銷行動。',
    pillarAwaiting: '請確認',
    modulesEyebrow: '已確認的模組表達',
    modulesTitle: '產品與能力如何共同支撐核心價值',
    modulesCount: '{count} 條已確認',
    moduleAction: '已確認 · 檢視完整表達',
    noCoreTitle: '核心表達尚未形成',
    noCoreBody: 'Navigator 需要已確認的企業資料與人的意志，才能提出核心表達。',
    noModulesBody: '已確認的產品與能力表達會顯示在這裡。',
  },
  connections: {
    eyebrow: '從一個階段走向下一個階段',
    title: '每一次行動，都讓下一次更準確',
    body: '你可以看到上一輪做了什麼、市場如何回應，以及這些結果如何改變下一步。',
    onlineOutcomes: '{count} 項在線成果',
    journeyEyebrow: '一條連續的行動',
    journeyTitle: '從判斷到執行，再讓結果改變下一階段',
    steps: {
      stage: '辨識階段',
      stageHint: '業務目標、買家問題與認知缺口',
      strategy: '制定策略',
      strategyHint: '階段主題、競爭位置與成功判準',
      work: '推進工作',
      workHint: '組織內容、頁面、發布與協作任務',
      results: '接收結果',
      resultsHint: 'AI 答案、線索池與使用者問卷',
      next: '下一階段',
      nextHint: '維持、調整或更換策略並沉澱經驗',
    },
    note: '領航者會同時參考 AI 答案、線索與使用者回饋。有效方向會被延續，沒有帶來結果的嘗試也會被記住，讓下一階段少走彎路。',
    recentTitle: '最近一次完整行動',
    recentBody: '從發現買家問題，到雙語指南上線，再到把結果用於下一輪內容。',
    noRecentBody: '目前尚未記錄完整的行動脈絡。',
    viewProcess: '檢視完整過程',
    accumulatedTitle: '領航者已經累積了什麼',
    accumulatedBody: '這些記錄幫助後續工作從既有經驗繼續，而不是每次重新開始。',
    stats: {
      live: '已上線成果',
      attempts: '已記錄的嘗試',
      judgments: '經驗判斷',
      actions: '完整行動',
    },
  },
  airlockGap: {
    eyebrow: '來自 Airlock 發布',
    title: '補齊 Airlock 回答所需的企業依據',
    subject: '需要補充的主題',
    status: '目前狀態',
    statusPending: '等待補充資料',
    statusQueued: '資料已提交 · 等待處理',
    statusSynced: '已同步 · 可以返回複測',
    flowLabel: '知識補齊流程',
    flow: {
      supply: '補充事實',
      classify: '資料分域',
      confirm: '確認知識',
      retest: '返回複測',
    },
    reason: {
      missing_knowledge: '已確認的企業資料裡還沒有這個問題的可靠答案。請補充原始依據，或寫清楚準確的業務事實。',
      conflicting_knowledge: '現有資料對這個問題說法不一致。請補充目前有效的權威口徑，並說明它取代了什麼。',
      knowledge_not_public: '企業內部已有相關資訊，但 Airlock 還不能公開使用。請補充可公開的表述，或返回選擇安全收口。',
      knowledge_not_synced: '已確認知識還沒有同步到這個 Airlock 的使用範圍。請核對現有知識，或在這裡補上缺少的依據。',
      not_applicable_review: '這個事項仍需要業務判斷。適用時請補充事實；不適用時請返回 Airlock 確認。',
    },
    queuedBody: '你補充的內容已進入資料處理佇列。只有它成為已確認知識並同步到目前 Airlock 後，發布缺口才會關閉。',
    addStatement: '補充事實說明',
    submitted: '事實說明已提交',
    reviewKnowledge: '檢視現有知識',
    returnToAirlock: '返回 Airlock 發布',
    correctionTitle: '為這個 Airlock 缺口補充依據',
    correctionBody: '請寫可核驗的業務事實，並盡量說明來源。提交不會直接公開，也不會提前關閉缺口。',
    correctionLabel: '業務事實或依據',
    correctionPlaceholder: '例如：標準規格最低訂購量為 500 件，依據為 2026 年現行銷售政策……',
    correctionSubmit: '提交處理',
    queuedToast: '資料已收到；知識確認並同步前，Airlock 缺口仍保持開啟。',
  },
  states: {
    loadingTitle: '正在匯合企業記憶',
    loadingBody: '領航者正在讀取事實、策略、執行、結果與經驗。尚未讀到的內容不會顯示為 0，也不會被當作不存在。',
    emptyEyebrow: '新企業',
    emptyTitle: '這家企業的記憶還沒有開始',
    emptyBody: '先接入官網與資料。領航者會先做功課，只把真正需要你判斷的部分帶回來。',
    connectMaterial: '接入第一份資料',
    readWebsite: '先讀取官網',
    errorEyebrow: '讀取失敗',
    errorTitle: '暫時無法讀取企業記憶',
    errorBody: '既有記憶沒有遺失，也不會被空白覆蓋。你可以重新讀取，或檢視上一次可信快照。',
    retry: '重新讀取',
    lastSnapshot: '檢視上次可信快照',
    snapshotUnavailable: '目前工作階段沒有可用的可信快照。',
    humanEyebrow: '需要你的決定',
    humanTitle: '領航者找到了不只一個成立的方向',
    humanBody: '它不會替你選擇。請比較選項，並確認最符合企業意志的表達。',
    choose: '前往選擇',
    later: '稍後處理',
    decisionDeferred: '這項決定仍在等待中，系統沒有改變方向。',
  },
  detail: {
    eyebrow: '記憶詳情',
    correct: '這裡需要修正',
    source: '檢視來源',
    correctionTitle: '修正領航者的理解',
    correctionBody: '你的修正會成為新的輸入，但不會靜默覆蓋已確認事實與原始來源。',
    correctionLabel: '你的修正',
    correctionPlaceholder: '例如：買家首先選擇我們的原因是長期可控，而不只是某個功能更方便……',
    cancel: '取消',
    submit: '提交修正',
    submitting: '正在提交…',
    correctionQueued: '修正已收到；完成分域後，才會進入企業記憶。',
    correctionFailed: '修正目前無法提交。',
    fields: {
      id: '記錄 ID',
      locale: '原文語言',
      source: '來源',
      scope: '適用範圍',
      confidence: '信心值',
      status: '狀態',
      question: '買家問題',
      platform: '平台',
      output: '關聯成果',
    },
  },
} satisfies MemoryDictionary

export default memory
